var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"release_123"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import { rewriteFramesIntegration } from "@sentry/integrations";
import * as Sentry from "@sentry/nextjs";
import { decodeText } from "lib/utils/decode";

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  // Replay may only be enabled for the client-side
  integrations: [
    Sentry.replayIntegration(),
    rewriteFramesIntegration({
      prefix: "~/",
      iteratee(frame) {
        // The [[...slug]] page is being encoded as %5B%5B...slug%5D%5D
        // This is a workaround to decode the URL correctly in Sentry
        if (frame.filename && typeof frame.filename === "string") {
          frame.filename = decodeText(frame.filename);
        }

        if (frame.abs_path && typeof frame.abs_path === "string") {
          frame.abs_path = decodeText(frame.abs_path);
        }

        return frame;
      },
    }),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  // ...

  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
  release: process.env.SENTRY_RELEASE,
  environment: process.env.NEXT_PUBLIC_DEPLOYED_ENV,
  dist: process.env.SENTRY_DIST,
});
